import MessageItem from "./message-item";
import type { KbContentData } from "@/utils/knowledge-content";

export type Reference = {
  reference_number: number;
  title: string;
  url: string;
  content: string;
};

export type UploadedFile = {
  fileId: number;
  filename: string;
  documentId: string;
  mimeType: string;
  createdAt: string;
  uploadStatus?: string;
  sdfJobName?: string;
};

export type Message = {
  id: string;
  chatId: string;
  conversationTime: string;
  message: string;
  messageType: "USER" | "ASSISTANT";
  tool: string;
  referencesContent?: Reference[];
  knowledgeContent?: KbContentData;
  chatType?: "DeepResearch";
  isGenerateFinalReport?: boolean;
  uploadedFiles?: UploadedFile[];
  sdfJobName?: string;
};

const MessageList = ({
  messages,
  onItemMount,
  pollLoading,
}: {
  messages: Message[];
  onItemMount: (
    message: Message,
    index: number,
    el: HTMLDivElement | null
  ) => void;
  pollLoading?: { active: boolean; chatType?: string };
}) => {
  return (
    <ul className="flex flex-col gap-[28px] w-full max-w-[756px] h-full pb-[150px] px-4">
      {messages?.map((message, index) => (
        <div ref={(el) => onItemMount(message, index, el)} key={index}>
          <MessageItem
            message={message}
            messageIndex={index}
            isLastMessage={index === messages.length - 1}
            previousMessage={messages[index - 1]}
          />
        </div>
      ))}
      {pollLoading?.active && (
        <li className="flex items-center gap-3">
          <div className="flex justify-center items-center w-12 h-12">
            <div className="w-8 h-8 border-4 border-primary-80 border-t-primary-40 rounded-full animate-spin" />
          </div>
          <span className="text-grey-20 text-base font-light">
            {pollLoading.chatType === "DeepResearch"
              ? "Conducting deep research and generating insights…"
              : "관련 정보 검색 중입니다 ..."}
          </span>
        </li>
      )}
    </ul>
  );
};

export default MessageList;
